module.exports = __webpack_public_path__ + "static/header-07b9071daae709f1dbb76c2bc13112e7.png";